import { koComponent } from "../../ko-utils";
import $api from "../../api";
import {
  getDomainFromUrl,
  urlize,
  addDomainIfNeeded,
  replaceAll,
} from "../../utils/core";
import { uploadImageFromExistingImgElementAsync } from "../../utils/io";
import ImgEx from "../../components/imgEx";
import languages from "../../utils/languages";

class AddNewProject {
  constructor(params, rootPageParent) {
    ImgEx();

    this.showIntroDashboard = params.showIntroDashboard; // not used in the end
    this.wizardStep = ko.observable(0);

    this.isFetchingName = ko.observable(false);

    this.languages = languages.sort((a, b) => (a.English > b.English ? 1 : -1));

    this.selectedLanguageForAdd = ko.observable("en");

    this.projectName = ko.observable("").extend({ required: true });
    this.baseUrl = ko.observable("").extend({ required: true });
    this.projectColor = ko.observable();
    this.rootPageParent = rootPageParent;

    this.iconUrl = ko.observable();

    $("#new-workspace-name").focus();
  }

  async fetchNameStep() {
    if (ko.unwrap(this.baseUrl.hasError)) return;

    $("#new-workspace-name").blur();

    //TODO: fetch or abort in about 2 secon
    this.isFetchingName(true);

    this.baseUrl(urlize(this.baseUrl()));
    const domainToCheck = getDomainFromUrl(this.baseUrl());

    TRACK_EVENT("Projects", "Trying to get workspace URL");

    try {
      const response = await fetch(
        "https://vtvu756cp3.execute-api.us-east-2.amazonaws.com/default/scraper",
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ url: domainToCheck }),
        }
      );

      const page = await response.json();

      if (page) {
        if (page.icons && page.icons && page.icons.length) {
          const bestIcon = getBestIconUrl(page.icons);

          this.iconUrl(addDomainIfNeeded(domainToCheck, bestIcon));

          function getBestIconUrl(icons) {
            const appleIcons = icons.filter(
              (i) => i.reference == "apple-touch-icon" && i.size
            );
            if (appleIcons.length) return appleIcons[0].url;
            const ordinaryIcons = icons.filter((i) => i.reference == "icon");
            if (ordinaryIcons.length) return ordinaryIcons[0].url;

            if (icons.length) return icons[0].url;

            return "";
          }
        }

        if (page.title) {
          this.projectName(replaceAll(page.title, "&amp;", "&"));
        }

        if (page.themeColor) {
          this.projectColor(page.themeColor);
        }

        TRACK_EVENT("Projects", "Fetched workspace URL");
      }
    } catch (e) {
      console.error("Scraping issue", e);
    }

    TRACK_EVENT("Projects", "Creating - domain entered");

    this.isFetchingName(false);
    this.wizardSetStep(1);
  }

  save() {
    if (ko.unwrap(this.rootPageParent.isSubmitting("createProject"))) {
      return;
    }

    this.rootPageParent.startSubmitting("createProject");

    var alpha = ko.unwrap(this.selectedLanguageForAdd)?.alpha2;

    $api.projects.create(
      {},
      {
        name: ko.unwrap(this.projectName),
        baseUrl: ko.unwrap(this.baseUrl),
        color: ko.unwrap(this.projectColor),
        supportedLanguages: alpha ? [alpha] : ["en"],
      },
      async (r) => {
        TRACK_EVENT("Projects", "Created");

        if (r.uniqueCode) {
          try {
            await uploadImageFromExistingImgElementAsync(
              r.uniqueCode,
              document.getElementById("workspace-avatar-wizard")
            );
          } catch (e) {
            console.error(e);
          }

          window.location.href = `/${r.uniqueCode}/dashboard/overview?welcome=true`;
        } else {
          // just for sure..
          this.rootPageParent.stopSubmitting("createProject");
          this.rootPageParent.loadProjects();
          this.rootPageParent.closeDialog();
        }
      },
      (e) => {
        console.error(e);
      }
    );
  }

  goUp() {
    const prevIndex = this.wizardStep() - 1;

    this.wizardSetStep(prevIndex);
  }

  wizardSetStep(step, stepId = null, skipAnimation = false) {
    this.wizardStep(step);

    setTimeout(() => {
      const el = document.getElementById(
        "ws-" + (stepId != null ? stepId : this.wizardStep())
      );

      el &&
        el.scrollIntoView({
          behavior: skipAnimation === true ? "auto" : "smooth",
        });
    }, 100);
  }

  closeWizard() {
    this.rootPageParent.closeDialog();
  }
}

export default koComponent("AddNewProject", AddNewProject);
